import { useState, useRef, useEffect } from 'react';
import { makeAPI } from '@spoketree-core-lib/api';
import lodash from 'lodash';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function makeItemsAPI$1(_ref) {
  var endpoint = _ref.endpoint,
    partition = _ref.partition,
    scope = _ref.scope,
    level = _ref.level,
    set = _ref.set;
    _ref.keys;
  var itemsResource = function itemsResource(params) {
    return makeAPI(endpoint, "/partitions/".concat(partition, "/scopes/").concat(scope, "/levels/").concat(level, "/sets/").concat(set) + (params !== null && params !== void 0 && params.latest ? "/_latest/".concat(params === null || params === void 0 ? void 0 : params.latest) : ''));
  };
  var itemResource = function itemResource(_ref2) {
    var key = _ref2.key;
    return makeAPI(endpoint, "/partitions/".concat(partition, "/scopes/").concat(scope, "/levels/").concat(level, "/sets/").concat(set, "/keys/").concat(key));
  };
  var getItems = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref3) {
      var latest;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              latest = _ref3.latest;
              _context.next = 3;
              return itemsResource({
                latest: latest
              }).retrieve();
            case 3:
              return _context.abrupt("return", _context.sent);
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function getItems(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var postItems = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(items) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return itemsResource().post(items);
            case 2:
              return _context2.abrupt("return", _context2.sent);
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function postItems(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var putItem = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref6) {
      var key, content, previousEventId;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              key = _ref6.key, content = _ref6.content, previousEventId = _ref6.previousEventId;
              _context3.next = 3;
              return itemResource({
                /*scope, level, set,*/key: key
              }).update({
                content: content,
                previousEventId: previousEventId
              });
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function putItem(_x3) {
      return _ref7.apply(this, arguments);
    };
  }();
  var deleteItem = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref8) {
      var key, previousEventId;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              key = _ref8.key, previousEventId = _ref8.previousEventId;
              _context4.next = 3;
              return itemResource({
                key: key
              }).delete({
                previousEventId: previousEventId
              });
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function deleteItem(_x4) {
      return _ref9.apply(this, arguments);
    };
  }();
  return {
    getItems: getItems,
    postItems: postItems,
    putItem: putItem,
    deleteItem: deleteItem
  };
}

var wrapItems$1 = function wrapItems(_ref) {
  var endpoint = _ref.endpoint,
    partition = _ref.partition,
    scope = _ref.scope,
    level = _ref.level,
    set = _ref.set,
    keys = _ref.keys,
    items = _ref.items,
    setItems = _ref.setItems;
  if (items.constructor !== Array) {
    var api = makeItemsAPI$1({
      endpoint: endpoint,
      partition: partition,
      scope: scope,
      level: level,
      set: set
    });
    var _parseItemContent = function _parseItemContent(items, set, key) {
      var _items$;
      return items && items["".concat(set, ":").concat(key)] ? (_items$ = items["".concat(set, ":").concat(key)][0]) === null || _items$ === void 0 ? void 0 : _items$.Version_Content : undefined;
    };
    var _putItem = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(items, scope, level, set, key, content) {
        var existingItem, previousEventId, responseItems;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                existingItem = items["".concat(set, ":").concat(key)];
                previousEventId = existingItem ? existingItem[0].H_SK.split('#')[3] : undefined;
                _context.next = 5;
                return api.putItem({
                  scope: scope,
                  level: level,
                  set: set,
                  key: key,
                  content: content,
                  previousEventId: previousEventId
                });
              case 5:
                responseItems = _context.sent;
                setItems && setItems(_objectSpread2(_objectSpread2({}, items), responseItems));
                _context.next = 14;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.log('_putItem failed');
                console.log(_context.t0);
                throw _context.t0;
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));
      return function _putItem(_x, _x2, _x3, _x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }();

    // SETUP parser, mutators and creators
    var parsers = {};
    var mutators = {};
    var creators = {};
    keys.forEach(function (key) {
      parsers[key] = function (items) {
        return function () {
          return _parseItemContent(items, set, key);
        };
      };
      mutators[key] = function (items) {
        return function (content) {
          return _putItem(items, scope, level, set, key, content);
        };
      };
      creators[key] = function (items) {
        return function (content) {
          var existingItem = items["".concat(set, ":").concat(key)];
          var previousEventId = existingItem ? existingItem[0].H_SK.split('#')[3] : undefined;
          return {
            scope: scope,
            level: level,
            set: set,
            key: key,
            content: content,
            previousEventId: previousEventId
          };
        };
      };
    });

    // WRAP items
    return {
      _items: items,
      keys: function keys() {
        return Object.keys(items);
      } /*{
        return wrapped ? Object.entries(wrapped).map(([ key, value ]) => {
        key,
        value[0]?.Version_Content
        }) : [];
        }*/,
      parse: function parse(key) {
        return Object.keys(parsers).includes(key) ? parsers[key](items)() : undefined;
      },
      parser: function parser(key) {
        return Object.keys(parsers).includes(key) ? parsers[key](items) : undefined;
      },
      mutate: function mutate() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (args.length === 2) {
          var key = args[0],
            content = args[1];
          if (Object.keys(mutators).includes(key)) {
            mutators[key](items)(content);
          } else {
            throw Error('Mutator not found');
          }
        } else if (args.length === 1 && _typeof(args[0]) === 'object') {
          var __items = Object.entries(args[0]).map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
              key = _ref4[0],
              content = _ref4[1];
            return creators[key](items)(content);
          });
          api.postItems(__items);
        } else {
          throw Error('Invalid arg count for mutate');
        }
      },
      mutator: function mutator(key) {
        if (Object.keys(mutators).includes(key)) {
          return mutators[key](items);
        } else {
          throw Error('Mutator not found');
        }
      },
      increment: function increment(key) {
        if (Object.keys(mutators).includes(key)) {
          var parsed = parsers[key](items)();
          var mutator = mutators[key](items);
          mutator(parsed + 1);
        } else {
          throw Error('Mutator not found');
        }
      },
      decrement: function decrement(key, min) {
        if (Object.keys(mutators).includes(key)) {
          var parsed = parsers[key](items)();
          var mutator = mutators[key](items);
          if (min < parsed - 1) {
            mutator(parsed - 1);
          }
        } else {
          throw Error('Mutator not found');
        }
      }
    };
  } else {
    return items;
  }
};

var _defaults$1 = {
  items: {},
  isInitialized: true,
  isRetrieveAttempted: false
};
var useSpoketreeDatabaseAuthItems$1 = function useSpoketreeDatabaseAuthItems(_ref) {
  var _ref$endpoint = _ref.endpoint,
    endpoint = _ref$endpoint === void 0 ? 'spoketree-database-auth' : _ref$endpoint,
    partition = _ref.partition,
    scope = _ref.scope,
    level = _ref.level,
    set = _ref.set,
    keys = _ref.keys,
    latest = _ref.latest,
    isAuthenticated = _ref.isAuthenticated,
    dependencies = _ref.dependencies,
    onInit = _ref.onInit,
    onError = _ref.onError,
    onLoad = _ref.onLoad;
  var api = makeItemsAPI$1({
    endpoint: endpoint,
    partition: partition,
    scope: scope,
    level: level,
    set: set
  });
  var _useState = useState(_defaults$1.items),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var isInitialized = useRef(_defaults$1.isInitialized);
  var isRetrieveAttempted = useRef(_defaults$1.isRetrieveAttempted);
  useEffect(function (_) {
    (function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        var receivedItems;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!dependencies || lodash.every(dependencies, Boolean))) {
                  _context.next = 30;
                  break;
                }
                if (!(!isAuthenticated && !isInitialized.current)) {
                  _context.next = 8;
                  break;
                }
                isInitialized.current = _defaults$1.isInitialized;
                isRetrieveAttempted.current = _defaults$1.isRetrieveAttempted;
                setItems(_defaults$1.items);
                onInit && onInit();
                _context.next = 30;
                break;
              case 8:
                if (!(isAuthenticated && !isRetrieveAttempted.current)) {
                  _context.next = 30;
                  break;
                }
                isInitialized.current = false;
                isRetrieveAttempted.current = true;
                _context.prev = 11;
                _context.next = 14;
                return api.getItems({
                  latest: latest
                });
              case 14:
                receivedItems = _context.sent;
                setItems(receivedItems);
                // call onLoad for actions that need to occur once when loaded
                // use this hook return value { items } for access to items
                _context.t0 = onLoad;
                if (!_context.t0) {
                  _context.next = 20;
                  break;
                }
                _context.next = 20;
                return onLoad(wrapItems$1({
                  endpoint: endpoint,
                  partition: partition,
                  scope: scope,
                  level: level,
                  set: set,
                  keys: keys,
                  items: receivedItems,
                  setItems: setItems
                }));
              case 20:
                _context.next = 28;
                break;
              case 22:
                _context.prev = 22;
                _context.t1 = _context["catch"](11);
                console.log("Error while retrieving items");
                console.log(_context.t1);
                setItems(_defaults$1.items);
                onError && onError();
              case 28:
                _context.next = 30;
                break;
              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[11, 22]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    })()();
  }, [isAuthenticated].concat(_toConsumableArray(dependencies ? dependencies : [])));
  return {
    items: wrapItems$1({
      endpoint: endpoint,
      partition: partition,
      scope: scope,
      level: level,
      set: set,
      keys: keys,
      items: items,
      setItems: setItems
    })
  };
};

var _defaults = {
  items: {},
  isInitialized: true,
  isRetrieveAttempted: false
};
var useSpoketreeDatabaseUnauthItems$1 = function useSpoketreeDatabaseUnauthItems(_ref) {
  var _ref$endpoint = _ref.endpoint,
    endpoint = _ref$endpoint === void 0 ? 'spoketree-database-unauth' : _ref$endpoint,
    partition = _ref.partition,
    scope = _ref.scope,
    level = _ref.level,
    set = _ref.set,
    keys = _ref.keys,
    _ref$isReady = _ref.isReady,
    isReady = _ref$isReady === void 0 ? true : _ref$isReady,
    onInit = _ref.onInit,
    onError = _ref.onError,
    onLoad = _ref.onLoad;
  var api = makeItemsAPI$1({
    endpoint: endpoint,
    partition: partition,
    scope: scope,
    level: level,
    set: set
  });
  var _useState = useState(_defaults.items),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var isInitialized = useRef(_defaults.isInitialized);
  var isRetrieveAttempted = useRef(_defaults.isRetrieveAttempted);
  useEffect(function (_) {
    (function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        var receivedItems;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!isReady && !isInitialized.current)) {
                  _context.next = 7;
                  break;
                }
                isInitialized.current = _defaults.isInitialized;
                isRetrieveAttempted.current = _defaults.isRetrieveAttempted;
                setItems(_defaults.items);
                onInit && onInit();
                _context.next = 29;
                break;
              case 7:
                if (!(isReady && !isRetrieveAttempted.current)) {
                  _context.next = 29;
                  break;
                }
                isInitialized.current = false;
                isRetrieveAttempted.current = true;
                _context.prev = 10;
                _context.next = 13;
                return api.getItems();
              case 13:
                receivedItems = _context.sent;
                setItems(retrievedItems);
                // call onLoad for actions that need to occur once when loaded
                // use this hook return value { items } for access to items
                _context.t0 = onLoad;
                if (!_context.t0) {
                  _context.next = 19;
                  break;
                }
                _context.next = 19;
                return onLoad(wrapItems$1({
                  endpoint: endpoint,
                  partition: partition,
                  scope: scope,
                  level: level,
                  set: set,
                  keys: keys,
                  items: receivedItems,
                  setItems: setItems
                }));
              case 19:
                _context.next = 27;
                break;
              case 21:
                _context.prev = 21;
                _context.t1 = _context["catch"](10);
                console.log("Error while retrieving items");
                console.log(_context.t1);
                setItems(_defaults.items);
                onError && onError();
              case 27:
                _context.next = 29;
                break;
              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[10, 21]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    })()();
  }, [isReady]);
  return {
    items: wrapItems$1({
      endpoint: endpoint,
      partition: partition,
      scope: scope,
      level: level,
      set: set,
      keys: keys,
      items: items,
      setItems: setItems
    })
  };
};

/*
 *   Copyright (c) 2021 Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var makeItemsAPI = makeItemsAPI$1;
var useSpoketreeDatabaseAuthItems = useSpoketreeDatabaseAuthItems$1;
var useSpoketreeDatabaseUnauthItems = useSpoketreeDatabaseUnauthItems$1;
var wrapItems = wrapItems$1;
var index = {
  makeItemsAPI: makeItemsAPI,
  wrapItems: wrapItems,
  useSpoketreeDatabaseAuthItems: useSpoketreeDatabaseAuthItems,
  useSpoketreeDatabaseUnauthItems: useSpoketreeDatabaseUnauthItems
};

export { index as default, makeItemsAPI, useSpoketreeDatabaseAuthItems, useSpoketreeDatabaseUnauthItems, wrapItems };
